<template>
	<div class="padding-lg">
		<el-card class="box-card" :body-style="{ padding: 0 }">
			<div slot="header" class="clearfix">
				<div class="flex justify-between align-center">
					<div class="flex align-center">
						<span class="el-icon-view"></span>
						<span class="text-bold margin-left-sm">{{ $route.meta.title }}</span>
					</div>
					<div class="flex align-center"></div>
				</div>
			</div>
			<div class="padding-top-xl">
				<div class="infoshow">
					<div class="title">合同编号：</div>
					<div class="con">
						<span>{{ info.number }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">合同类型：</div>
					<div class="con">
						<span class="cu-tag bg-pink round" v-if="info.type == 1">销售合同</span>
						<span class="cu-tag bg-purple round" v-else-if="info.type == 2">采购合同</span>
						<span class="cu-tag bg-grey round" v-else>未知</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">合同分类：</div>
					<div class="con">
						<span class="">{{ info.info_class.name }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">关联客户：</div>
					<div class="con">
						<div>
							<span class="text-lg text-bold">{{ info.customer.name }}</span>
						</div>
						<div>
							<span class="text-grey">{{ info.customer.credit_code }}</span>
						</div>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">联系人：</div>
					<div class="con">
						<span class="text-lg text-bold">{{ info.contacter.name }}</span>
						（
						<span class="text-grey">{{ info.contacter.mobile }}</span>
						）
					</div>
				</div>
				<div class="infoshow">
					<div class="title">签约时间：</div>
					<div class="con">
						<span class="">{{ info.sign_time }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">签约人：</div>
					<div class="con"><popover-user-card :info="info.sign_user" v-if="info.sign_user"></popover-user-card></div>
				</div>
				<div class="infoshow">
					<div class="title">合同描述：</div>
					<div class="con">
						<span class="">{{ info.description }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">合同照片：</div>
					<div class="con">
						<div class="avatar-uploader">
							<div class="el-upload-list el-upload-list--picture-card">
								<div class="el-upload-list__item is-ready" v-for="(item, index) in info.picture" :key="index">
									<el-image class="el-upload-list__item-thumbnail" :src="item.url" :alt="item.name" :preview-src-list="previewList"></el-image>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">备注：</div>
					<div class="con">
						<span class="">{{ info.remark }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">上传时间：</div>
					<div class="con">
						<span class="">{{ info.addtime }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">上传者：</div>
					<div class="con"><popover-user-card :info="info.add_user" v-if="info.add_user"></popover-user-card></div>
				</div>
				<div class="infoshow">
					<div class="title">归档状态：</div>
					<div class="con">
						<span class="cu-tag bg-red round" v-if="info.stateflag == 0">未提交</span>
						<span class="cu-tag bg-blue round" v-else-if="info.stateflag == 1">待处理</span>
						<span class="cu-tag bg-green round" v-else-if="info.stateflag == 6">已归档</span>
						<span class="cu-tag bg-grey round" v-else>未知</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">归档时间：</div>
					<div class="con">
						<span>{{ info.archive_time }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title">归档人员：</div>
					<div class="con"><popover-user-card :info="info.archive_user" v-if="info.archive_user"></popover-user-card></div>
				</div>

				<el-divider content-position="left"></el-divider>
			</div>
		</el-card>
		<el-dialog title="处理订单" :visible.sync="dialogVisibleDeal" width="600px">
			<el-form ref="formDeal" :model="formDeal" label-width="130px" label-suffix=":">
				<el-form-item required="" label="处理结果">
					<el-radio-group v-model="formDeal.state"><el-radio label="通过" :value="6"></el-radio></el-radio-group>
				</el-form-item>
				<el-form-item required="" prop="reply" label="处理回执">
					<el-input v-model="formDeal.reply" type="textarea" placeholder="请输入处理回执" :rows="5" maxlength="140" show-word-limit></el-input>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import popoverUserCard from '@/components/popover-user-card.vue';
export default {
	components: { popoverUserCard },
	data() {
		return {
			id: '',
			info: {
				sign_user: {},
				add_user: {},
				review_user: {},
				archive_user: {},
				info_class: {},
				customer: {},
				contacter: {},
				picture: []
			},
			previewList:[],
			formDeal: {},
			dialogVisibleDeal: false
		};
	},
	beforecreate: function() {},
	created: function() {
		if (this.$route.params.id) {
			this.id = this.$route.params.id;
		} else {
			this.$alert('页面参数错误！', {
				title: '操作错误',
				type: 'error',
				callback: r => {
					this.$router.back(-1);
				}
			});
			return false;
		}
		const loading = this.$loading({
			lock: true,
			text: '加载中...',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		this.$http.post('/server/index.php?m=contract/archive&a=view', { id: this.id }).then(
			res => {
				loading.close();
				if (typeof res.data != 'object') {
					this.$alert(res.data ? res.data : '(无返回数据)', {
						title: '返回数据格式错误',
						type: 'error'
					});
				} else {
					if (res.data.result == 'ok') {
						this.info = res.data.data.info;
						if(this.info.picture.length>0){
							let previewList=[];
							for(let i=0;i<this.info.picture.length;i++){
								previewList.push(this.info.picture[i].url);
							}
							this.previewList=previewList;
						}
					} else {
						this.$alert(res.data.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				}
			},
			r => {
				loading.close();
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {}
};
</script>

<style>
.infoshow .title {
	min-width: 150px;
}
</style>
